<template>
  <vx-card>

      <vs-popup @accept="exportToExcel" :active.sync="activePrompt" :buttons-hidden="true">
        <div class="px-8 py-10 md:p-12">
          <p class="titles mb-8">Export</p>
          <label>File Name</label>
          <vs-input v-model="filename" placeholder="Type your file name" class="w-full mb-8"/>
          <label>Extension</label>
          <v-select v-model="selectedFormat" :options="formats" class="w-full"/>
          <div class="flex flex-wrap mt-10 md:justify-end">
            <vs-button class="primary-btns w-full mb-4 md:w-48 md:order-last md:ml-4" @click="exportToExcel">Export</vs-button>
            <vs-button class="cancel-btns w-full md:w-32" type="border" text-color="#2C2C2C" @click="() => {
              activePrompt=false;
              clearFields();
            }">Cancel</vs-button>
          </div>
        </div>
      </vs-popup>

      <div class="flex flex-wrap md:flex-no-wrap md:items-baseline">
        <p class="titles w-full mb-5 md:mb-10">Activity Log</p>
        <div class="flex flex-wrap w-full md:flex-no-wrap md:justify-end">
          <vs-button class="primary-btns w-full mb-4 md:mb-0 md:ml-5 md:w-40 md:order-last" @click="activePrompt=true">Export</vs-button>
        </div>
      </div>
      <vs-table class="mt-5" max-items="8" stripe pagination :data="logs">
        <template slot="thead" >
          <vs-th class="table-head">
            Date
          </vs-th>
          <vs-th class="table-head">
            Time
          </vs-th>
          <vs-th class="table-head">
            Description
          </vs-th>
          <vs-th class="table-head">
            Note
          </vs-th>
          <vs-th class="table-head">
            Amount
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td class="table-body" :data="data[indextr].date">
              {{data[indextr].date}}
            </vs-td>

            <vs-td class="table-body" :data="data[indextr].time">
              {{data[indextr].time}}
            </vs-td>

            <vs-td class="table-body" :data="data[indextr].description">
              {{data[indextr].description}}
            </vs-td>

            <vs-td class="table-body" :data="data[indextr].note">
              {{data[indextr].note}}
            </vs-td>

            <vs-td class="table-body" :data="data[indextr].amount">
              {{data[indextr].amount}}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
</template>

<script>

import exportFromJSON from 'export-from-json'
export default {
  data:() => ({
    logs:[
      {
        id: 1,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 2,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 3,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 5,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 6,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 7,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 8,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 9,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 10,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 11,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 12,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 13,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      },
      {
        id: 14,
        date: '29-Jan-2019',
        time: '12:50:21',
        description: 'Create Campagin',
        note: 'realstate campagin',
        amount: '$ 150'
      }
    ],
    dateRange: {
      startDate: new Date(),
      endDate: new Date()
    },
    activePrompt: false,
    formats:['xls', 'csv', 'txt', 'json'],
    filename: '',
    selectedFormat: 'xls',
    cellAutoWidth: true
  }),

  methods: {
    exportToExcel () {
      const { logs, filename, selectedFormat } = this
      exportFromJSON({ data: logs, fileName: filename, exportType: selectedFormat })
    },
    clearFields () {
      this.filename = ''
      this.selectedFormat = 'xlsx'
    }
  }
}
</script>


<style lang="scss" scoped>

.titles {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.primary-btns {
  height: 48px;
  background: #0092d7;
  border-radius: 3px;
}

.cancel-btns {
  height: 48px;
  background: #fff;
  border: 2px solid #d9d9d9;
  border-radius: 3px;
}

.prompt-titles {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.date-picker {
  height: 40px;
  background: #fff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 4px;
}

.table-head {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #404040;
}

.table-body {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;
}

</style>
